import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {createAllActions} from 'web-app/util/redux/typed-action-helpers';
import {type RecurringPayment} from 'web-app/react/entities/recurring-payments/model';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

const domain = 'ENTITIES/RECURRING_PAYMENTS';

export const {
    action: fetchBillPayerPayments,
    success: fetchBillPayerPaymentsSuccess,
    failed: fetchBillPayerPaymentsFailed,
} = createAction(
    `${domain}/FETCH_BILL_PAYER_PAYMENTS`,
    (institutionId, billPayerId) => ({institutionId, billPayerId}),
    (payload: {billPayerId: string; recurringPayments: RecurringPayment[]; behaviors: BehaviorsCollection}) => payload,
);

export const {
    action: createPayment,
    success: createPaymentSuccess,
    failed: createPaymentFailed,
} = createAllActions(
    `${domain}/CREATE_PAYMENT`,
    (institutionId: string, billPayerId: string, payment: any) => ({
        institutionId,
        billPayerId,
        payment,
    }),
    (payload: {newPayment: RecurringPayment; billPayerId: string; institutionId: string}) => payload,
);

export const {success: updatePaymentSuccess} = createAllActions(
    `${domain}/UPDATE_PAYMENT`,
    () => ({}),
    (payload: {updatedPayment: RecurringPayment; billPayerId: string; institutionId: string}) => payload,
);

export const {
    action: deletePayment,
    success: deletePaymentSuccess,
    failed: deletePaymentFailed,
    aborted: deletePaymentAborted,
} = createAction(`${domain}/DELETE_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));

export const {
    action: denyPayment,
    success: denyPaymentSuccess,
    failed: denyPaymentFailed,
    aborted: denyPaymentAborted,
} = createAction(`${domain}/DENY_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));
